import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { IHomeProps } from '../../types/PropTypes';
import { WithTranslation, withTranslation } from 'react-i18next';
import { companyNameReplace } from '../../utils';

export class Home extends Component<IHomeProps & WithTranslation> {
    render() {
        return (
            <>
                <Helmet>
                    <title>{companyNameReplace(this.props.t('dashboard.title'))}</title>
                </Helmet>
            </>
        );
    }
}

export default withTranslation()(Home);
